import React, { useState } from "react";

import { faBracketsCurly } from "@fortawesome/pro-regular-svg-icons";

import { Pill } from "src/base-components/Pill";
import { Tooltip } from "src/design-system/Tooltip";
import { JSONSchemaViewerDisplayOptions } from "src/jsonSchema/viewer/JSONSchemaRenderer";
import { ellipsizePath } from "src/jsonSchema/viewer/renderUtils";
import { ViewModelNode } from "src/jsonSchema/viewer/viewModelTreeBuilder";
import { copyTextToClipboard } from "src/utils/clipboard";

type PathBadgeProps = {
  path: string;
  displayOptions: JSONSchemaViewerDisplayOptions;
  node?: ViewModelNode;
};

export const PathBadge: React.FC<PathBadgeProps> = ({
  path,
  displayOptions,
  node,
}) => {
  const [copied, setCopied] = useState(false);

  if (node?.nodeType === "choice-only") {
    return null;
  }

  // Apply ellipsization based on display options
  const displayPath = ellipsizePath(
    path,
    displayOptions.pathEllipsizeDepth,
    displayOptions.pathPrefix,
  );

  return (
    <Tooltip placement="top" title={copied ? "Copied!" : path} asChild>
      <Pill
        size="sm"
        variant="indigo-light"
        maxWidth
        onClick={(e) => {
          e.stopPropagation();
          copyTextToClipboard(path).then(() => {
            setCopied(true);
            setTimeout(() => {
              setCopied(false);
            }, 2000);
          });
        }}
      >
        <Pill.Icon icon={faBracketsCurly} padding={false} />
        <div className="w-0.5" />
        <Pill.Text fontType="code-12">{displayPath}</Pill.Text>
      </Pill>
    </Tooltip>
  );
};
